import { replaceTempUUid } from "api/exchanges/exchangeUtils";
import type { ExchangeClient, ExchangeOperation } from "api/exchanges/types";

type ExeUpdateNodeFromQueueParams = {
  operation: ExchangeOperation;
  client: ExchangeClient;
  queue: Set<ExchangeOperation>;
  replaceKeysMap: Map<string, string>;
};

export const exeUpdateNodeFromQueue = ({
  operation,
  client,
  queue,
  replaceKeysMap,
}: ExeUpdateNodeFromQueueParams): void => {
  const parentId = operation.variables?.input?.parentId;
  const id = operation.variables?.id;
  if (parentId && parentId.startsWith("temp_")) {
    if (operation.variables && operation.variables.input) {
      operation.variables.input.parentId = replaceTempUUid({
        id: parentId,
        replaceKeysMap,
      });
    }
  }

  if (id && id.startsWith("temp_")) {
    if (operation.variables) {
      operation.variables.id = replaceTempUUid({
        id,
        replaceKeysMap,
      });
    }
  }

  client.reexecuteOperation({
    ...operation,
    context: {
      ...operation.context,
      requestPolicy: "network-only",
      fromQueue: true,
    },
  });
  queue.delete(operation);
};
